import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, IconButton } from '@mui/material';
import React from 'react';

import ImageGalleryViewer from '../components/ImageGalleryViewer';

const PlacePhotosDialog = (props) => {
    const [replace, setReplace] = React.useState(true);

    const toGalleryFormat = (list) => {
        return (list || []).map((x) => ({
            // `src` is resolved by placeToLegacy: getURI() is a method and a place
            // travels to the backend through JSON.stringify. Nothing calls the
            // deprecated PlacePhoto.getUrl() any more.
            src: x.src,
            selected: !!x.selected,
            width: 1,
            height: 1,
        }));
    };

    const onClose = () => {
        props.onClose && props.onClose();
    };

    const onSave = () => {
        props.onSave && props.onSave(replace);
    };

    return (
        <Dialog fullWidth={true} maxWidth="xl" open={props.open} style={{ zIndex: 100000 }} onClose={onClose}>
            <DialogTitle>
                <Grid container direction="row">
                    <Grid item xs={10}>
                        Images from Google
                    </Grid>
                    <Grid item xs={2} container justifyContent="flex-end">
                        <IconButton size="small" onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>Select the images that you would like to be stored for the activity</DialogContentText>
                <ImageGalleryViewer selectable={true} list={toGalleryFormat(props.images)} onChange={props.onChange} isSmallScreen={props.isSmallScreen} />
            </DialogContent>
            <DialogActions>
                <Grid container display="flex" justifyContent="space-between" alignItems="center">
                    <Box ml={3} my={1}>
                        <Button onClick={onSave} color="primary" variant="contained">
                            <SaveIcon />
                            &nbsp;Fetch
                        </Button>
                    </Box>
                    {+props.existingImagesCount > 0 ? <FormControlLabel control={<Checkbox checked={replace} color="primary" onChange={(ev) => setReplace(!replace)} />} label={`Replace ${props.existingImagesCount} existing image${props.existingImagesCount > 1 ? 's' : ''}`} /> : null}
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default PlacePhotosDialog;
